<div class="billing-container">
	<nb-card class="billing-preferences-container">
		<nb-card-body>
			<div>
				@if (collapsable) {
					<a id="toggle-order-details" class="toggle-details-section"
					   (click)="detailsVisible = !detailsVisible" data-test-id="billing-preferences-details-toggle">
						{{ detailsVisible ? 'Hide' : 'Show' }}
						<nb-icon
							icon="{{detailsVisible ? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline'}}"></nb-icon>
					</a>
				}

				<h5 id="card-header" [ngClass]="{'collapsed': !detailsVisible}">
					Billing preferences
				</h5>

				@if (detailsVisible) {
					<div id="billing-details" class="row-wrapper">
						<div class="col-md-12">
							@if (!editMode) {
								<billing-preview
									[order]="order"
									[editable]="editable"
									[countries]="countries$ | async"
									[changeSet]="changeSet"
									[multipleAppearance]="multipleAppearance"
									(openEditMode)="openEditMode()">
								</billing-preview>
							}
							@if (editMode) {
								<billing-info-edit
									[order]="order"
									[countries]="countries$ | async"
									(changesCanceled)="onChangesCanceled()"
									(changesSaved)="onChangesSaved($event)">
								</billing-info-edit>
							}
						</div>
					</div>
				}
			</div>
		</nb-card-body>
	</nb-card>
	@if (detailsVisible && showDekraInfo) {
		<nb-card>
			<nb-card-body>
				<dekra-billing-data></dekra-billing-data>
			</nb-card-body>
		</nb-card>
	}

</div>



